import type {
  CoreSelectionListItem,
  CoreSelectionListSelectedItem,
} from 'src/core/CoreSelectionList/types'

/** Приводит выбор к массиву: один пункт → `[пункт]`, массив → как есть, пусто → `[]`. */
export default function toSelectedItemsArray(
  selected?: CoreSelectionListSelectedItem,
): CoreSelectionListItem[] {
  if (!selected) {
    return []
  }

  if (Array.isArray(selected)) {
    return selected
  }

  return [selected]
}
